import { Component, Vue } from 'vue-property-decorator';

// gql
import fetchPartnerOptionsQuery from '@/graphql/queries/partners/FetchPartnerOptions.gql';

// types
import { PartnerFields } from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';

@Component({
  apollo: {
    partnerOptions: {
      query: fetchPartnerOptionsQuery,
      fetchPolicy: 'cache-and-network',
      debounce: 300,
      variables() {
        return {
          filter: {
            searchString: this.searchPartner || null
          }
        };
      },
      update(data): SelectOption<string>[] {
        if (data.partners) {
          return data.partners.map((partner: PartnerFields) => {
            return {
              label: partner.name,
              value: partner
            };
          });
        }
        return [];
      }
    }
  }
})

export default class PartnerOptionsMixin extends Vue {
  public partnerOptions: SelectOption<string>[] = [];
  public searchPartner = '';
}
